export default {"src":"/_next/static/media/lamb-outline-icon.a174c0e0.svg","height":29,"width":57,"blurWidth":0,"blurHeight":0};